export default function useArrayHelpers() {
  function findDuplicates(arr: any[]) {
    const seen = new Set();
    const duplicates = new Set(); // Use a Set to store unique duplicates

    for (const item of arr) {
      if (seen.has(item)) {
        duplicates.add(item); // Add to duplicates set if already seen
      } else {
        seen.add(item); // Otherwise, add to seen set
      }
    }

    return Array.from(duplicates); // Convert Set back to an array
  }

  function findDuplicatesWithCounts(arr: any[]) {
    const freqMap = new Map();
    arr.forEach(val => freqMap.set(val, (freqMap.get(val) || 0) + 1));

    // Extract only duplicates
    const duplicateResults = [...freqMap.entries()].filter(([_, count]) => count > 1);

    return duplicateResults;
  }
  return {
    findDuplicates,
    findDuplicatesWithCounts,
  };
}
